import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export function useSiteImage(slot: string, fallback: string): string {
  const [url, setUrl] = useState(fallback);

  useEffect(() => {
    supabase
      .from("site_images")
      .select("url")
      .eq("slot", slot)
      .maybeSingle()
      .then(({ data }) => {
        if (data?.url) setUrl(data.url);
      });
  }, [slot]);

  return url;
}
